import React, {memo} from 'react';
import {Link} from 'react-router-dom';
import {ROUTES} from '../../configs/routes';
import {t} from '../../services/i18nHandler';

const footerNavLinks = [
  {
    route: ROUTES.CONTACTS.route,
    text: 'footer.contacts',
  },
  {
    route: ROUTES.TECHNICAL_SUPPORT.route,
    text: 'footer.techSupport',
  },
  {
    route: ROUTES.SERVICE_TERMS.route,
    text: 'footer.conditions',
  },
  {
    route: ROUTES.SAFE_MNJ.route,
    text: 'footer.safeMnj',
  },
  {
    route: ROUTES.SOFTWARE_REQUIREMENTS.route,
    text: 'footer.requirements',
  },
  {
    route: ROUTES.LEGAL_DOCUMENTS.route,
    text: 'footer.documents',
  },
  {
    route: ROUTES.PROCESSING_POLICY.route,
    text: 'footer.policy',
  },
];

function FooterNav() {
  return (
    <div className="footer-nav">
      <ul className="footer-nav_list">
        {footerNavLinks.map((link, index) => (
          <li className="footer-nav_item" key={index}>
            <Link to={link.route} className="footer-nav_link">{t(link.text)}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

FooterNav.propTypes = {};

export default memo(FooterNav);
